import { mapActions, mapGetters, mapMutations } from "vuex";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import validation from "@/mixins/validation";

export default {
  name: "restorePhone",
  data() {
    return {
      payload: {
        password: "",
        password_confirmation: "",
        code: ""
      },
      showPassword: false,
      showPasswordConfirmation: false,
      validationErrors: {},
    };
  },
  mixins: [validation],
  validations: {
    payload: {
      code: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      },
      password: {
        required,
        minLength: minLength(8),
      },
      password_confirmation: {
        required,
        minLength: minLength(8),
        sameAsPassword: sameAs("password"),
      },
    },
  },
  watch: {
    "payload.code": function () {
      this.$v.$reset();
    },
    "payload.password": function () {
      this.$v.$reset();
    },
    "payload.password_confirmation": function () {
      this.$v.$reset();
    },
  },

  computed: {
    ...mapGetters({
      isLoading: "auth/isLoading",
      resetPhoneNumber: "auth/resetPhoneNumber",
    }),
    codeErrors() {
      return this.computeErrors("payload", "code", {
        required: "validationRequired",
        maxLength: { message: "validationMax", count: 6 },
        minLength: { message: "validationMin", count: 6 },
      });
    },
    passwordErrors() {
      return this.computeErrors("payload", "password", {
        minLength: { message: "validationMin", count: 8 },
        required: "validationRequired",
      });
    },
    passwordConfirmationErrors() {
      return this.computeErrors("payload", "password_confirmation", {
        minLength: { message: "validationMin", count: 8 },
        required: "validationRequired",
        sameAsPassword: "validationSameAs",
      });
    },
  },
  created() {
    document.getElementById("html").classList.add("hide");
  },
  methods: {
    ...mapMutations({
      changeRestorePopup: "popups/CHANGE_RESTORE_PHONE_POPUP",
    }),
    ...mapActions({
      restorePasswordWithPhone: "auth/RESTORE_PHONE_PASSWORD",
    }),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const localPayload = {
        ...this.payload,
        phone: this.resetPhoneNumber
      }
      this.restorePasswordWithPhone(localPayload)
        .then(() => {
          this.$toasted.success(this.$t("successRestorePassword"));
          this.$router.replace({ query: null }).catch(() => {});
          this.changeRestorePopup(false);
          window.location.reload()
        })
        .catch(error => {
          this.$toasted.error(error.data.message);
        });
    },
  },
};
